import { Skeleton } from '@//components/Skeleton';
import styles from './AsideActionCard.module.scss';

const FinanceSectionSkeleton = () => (
  <li className={styles.priceItem} aria-hidden="true">
    <Skeleton height="1.5rem" width="8rem" className={styles.priceLabel} />
    <Skeleton height="1.5rem" width="4rem" className={styles.priceValue} />
  </li>
);

export default FinanceSectionSkeleton;
